/** FR-OPS-04: the maintenance notice banner — in the signed-in app, on sign-in and on the party portal (public data only). */
import { useQuery } from '@tanstack/react-query';
import { Wrench } from 'lucide-react';
import { bannerText, type BannerNotice } from './api';

export function MaintenanceBanner() {
  const q = useQuery({
    queryKey: ['public', 'notices'],
    queryFn: async () => {
      const r = await fetch('/api/v1/public/notices', { credentials: 'omit' });
      return r.ok ? ((await r.json()) as BannerNotice[]) : [];
    },
    refetchInterval: 5 * 60_000,
    retry: false,
  });
  const list = q.data ?? [];
  if (!list.length) return null;
  return (
    <div role="status" className="bg-info-soft px-4 py-2 text-sm text-info">
      {list.slice(0, 2).map((n) => (
        <p key={n.id} className="mx-auto flex max-w-5xl items-start justify-center gap-2 text-center font-semibold">
          <Wrench aria-hidden className="mt-0.5 h-4 w-4 shrink-0" />
          <span>
            {bannerText(n)}{' '}
            <a href="/status" className="underline">Status</a>
          </span>
        </p>
      ))}
    </div>
  );
}
